var JSON = require("./json3.mod.js");

var logFunctions = ["log", "info", "warn", "error"];
var emptyFunc = function(){};

var logUtil = {

    bindContext: function (func, context) {

        try {
            if (func.__bound__ === true) {
                return func;
            }
        } catch(e) {}

        var boundFunc;

        if (Function.prototype.bind && Function.prototype.bind.prototype == null) {
            try {
                boundFunc = Function.prototype.bind.call(func, context);
            } catch(e) {}
        }

        if (boundFunc == null && Function.prototype.apply && Function.prototype.apply.prototype == null) {
            try {
                boundFunc = (function(){
                    Function.prototype.apply.call(func, context, [].slice.call(arguments));
                });
            } catch(e) {}
        }

        if (boundFunc == null) {
            boundFunc = emptyFunc;
        }

        try {
            boundFunc.__bound__ = true;
        } catch(e) {}

        return boundFunc;
    },

    getBoundLogFunc: function (funcName, context) {

        if (context == null) {
            return emptyFunc;
        }

        if (context[funcName] == null) {
            if (context.log == null ||
                context.log === emptyFunc) {
                return emptyFunc;
            }

            funcName = "log";
        }

        return this.bindContext(context[funcName], context);
    },

    copyLoggerFunctions: function (fromLogger, toLogger) {

        for (var logFuncName in logFunctions) {
            if (!logFunctions.hasOwnProperty(logFuncName)) continue;
            logFuncName = logFunctions[logFuncName];
            toLogger[logFuncName] = this.getBoundLogFunc(logFuncName, fromLogger);
        }
    },

    stringifyLogObject: function (logObject) {

        switch (typeof logObject) {
            case "string":
                return logObject;
            case "number":
            case "boolean":
                return logObject.toString();
            case "undefined":
                return "undefined";
            case "function":
                return logObject.toString();
            case "object":
                if ((logObject instanceof RegExp) || (logObject instanceof String) || (logObject instanceof Number) || (logObject instanceof Boolean)) {
                    return logObject.toString();
                }
                return JSON.stringify(logObject);
            default:
                return "unknown";
        }
    },

    stringifyLogArguments: function (args) {

        var str = "";
        for(var argKeys in args) {
            if (args.hasOwnProperty(argKeys)){
                str += this.stringifyLogObject(args[argKeys]);
            }
        }

        return str;
    },

    toLogFunction: function (relayFunction, logFunctionName) {

        var me = this;

        return (function () {
            relayFunction(logFunctionName, me.stringifyLogArguments([].slice.call(arguments)));
        });
    },

    /* Relay Functions
    function relayLogFunction (logFunctionName, args) {
        dpLogger[logFunctionName](args, new Date().getTime());
    }

    function relayLogFunction (logFunctionName, args) {
        extensionFrameProxy.postMessage("DebugLog", {
            level: logFunctionName,
            args: args,
            time: new Date().getTime()
        });
    }
    */
    createRelayLogger: function (relayFunction) {
        var logger = {};

        for (var i = 0; i < logFunctions.length; i++) {

            var logFunctionName = logFunctions[i];
            logger[logFunctionName] = this.toLogFunction(relayFunction, logFunctionName);
        }

        return logger;
    }
};


module.exports = logUtil;